var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 71,
    viewBox: "0 0 34 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 71C21.6944 71 25.5 69.6755 25.5 68.0416C25.5 66.4078 21.6944 65.0833 17 65.0833C12.3056 65.0833 8.5 66.4078 8.5 68.0416C8.5 69.6755 12.3056 71 17 71Z",
    fill: "#292F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22021 21.152C9.22021 21.152 14.6496 69.0238 17.002 69.0277C19.3522 69.0297 24.7795 21.152 24.7795 21.152H9.22021Z",
    fill: "#99AAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31.5556C26.3888 31.5556 34 24.4916 34 15.7778C34 7.06395 26.3888 0 17 0C7.61116 0 0 7.06395 0 15.7778C0 24.4916 7.61116 31.5556 17 31.5556Z",
    fill: "#DD2E44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji5);
export default __webpack_public_path__ + "static/media/emoji-5.c068ddd3970d402c642ea7ec9c4026cf.svg";
export { ForwardRef as ReactComponent };